import React, { useEffect, useState } from "react";
import styles from "./AllFixtures.module.css";
import { Link, Route, Routes } from "react-router-dom";
import AllMatchesList from "../../components/AllMatchesList/AllMatchesList";
import LiveMatchesList from "../../components/LiveMatchesList/LiveMatchesList";
import UpcomingMatchesList from "../../components/UpcomingMatchesList/UpcomingMatchesList";
import RecentMatchesList from "../../components/RecentMatchesList/RecentMatchesList";
import { useDispatch, useSelector } from "react-redux";
import { homeData } from "../../features/home/homeSlice";
import { newsData } from "../../features/news/newSlice";

const AllFixtures = () => {
  const [allFixtures, setallFixtures] = useState(true);
  const [recentematch, setrecentmatch] = useState(false);
  const [upcoming, setupcoming] = useState(false);


  const handleClick = (name) => {
    switch (name) {
      case "all":
        setallFixtures(true);
        setrecentmatch(false);
        setupcoming(false);

        break;
      case "up":
        setallFixtures(false);
        setrecentmatch(false);
        setupcoming(true);

        break;

      case "recent":
        setallFixtures(false);
        setrecentmatch(true);
        setupcoming(false);

        break;
      default:
        setallFixtures(true);
        setrecentmatch(false);
        setupcoming(false);
    }
  };
  return (
    <div className={styles.parentContainer}>
      <div className={styles.fixturesHeading}>
        <h3>All FIXTURES</h3>
      </div>

      <div className={styles.fixturesNavigation}>
        <ul className={styles.fixturesNavigationLinks}>
          <button onClick={() => handleClick("all")} className={` ${ allFixtures === true  ? styles.active : styles.inactive} ${styles.fixtureStatus} `}>All Fixtures</button>
          <button onClick={() => handleClick("up")} className={` ${upcoming  === true  ? styles.active : styles.inactive} ${styles.fixtureStatus} `}>Upcoming</button>
          <button onClick={() => handleClick("recent")} className={` ${ recentematch === true  ? styles.active : styles.inactive} ${styles.fixtureStatus} `}>Recent</button>
        </ul>
      </div>

      <div className={styles.fixtureCardsContainer}>
        {allFixtures && <AllMatchesList />}
        {recentematch && <RecentMatchesList />}
        {upcoming && <UpcomingMatchesList />}
      </div>
    </div>
  );
};

export default AllFixtures;
